<template>
  <div>
    <div class="contract">
      <HeaderNL :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >BIÊN BẢN THỎA THUẬN<br />
          KIỂM TRA VÀ CHẤP NHẬN THIẾT BỊ THANH TOÁN THẺ
        </b>
      </p>
      <p class="txt-center">(BB: <mark>...........</mark>)</p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán số
          <mark>{{ dataAppendix?.appendixNganluongConvert?.nganluongContractCode }}</mark> (sau đây
          được viết tắt là “Hợp đồng”) ký ngày
          <mark>{{
            dataAppendix?.dateSignAppendix || dataAppendix?.dateSignAppendixDTO | formatDate
          }}</mark>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>

        <mark v-else-if="dataAppendix.dateSignAppendix">{{
          dataAppendix.dateSignAppendix | formatDate
        }}</mark>
        <mark v-else>{{ new Date() | formatDate }}</mark>
        , tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p>(sau đây được gọi là “BÊN A”)</p>
      <div class="form form-ext">
        <p>
          Địa chỉ: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
          Nội, Việt Nam..
        </p>
        <p>Điện thoại: 1900-2079</p>
        <p>Mã số thuế: 0106001236</p>
        <p>Đại diện: <b>Ông NGUYỄN TIẾN LƯỢNG</b></p>
        <p>Chức vụ: <b>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></p>

        <p>Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026</p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>

      <p>Và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <span>
          <b>{{ customerInfo.merchantName || '' }}</b>
        </span>
      </p>
      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <span>
            {{ customerInfo.address || '' }}
          </span>
        </p>
        <p>
          Website:<span> {{ customerInfo.website || '' }}</span>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile || '' }}</mark>
          <span class="ml-4"> Fax: <mark></mark></span>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <span>
            {{ customerInfo.businessRegistrationNumber || '' }}
          </span>
        </p>
        <p>
          <span>Người đại diện: </span
          ><span
            ><b>{{ customerInfo.customerName || '' }}</b></span
          >
          <span class="ml-4"
            >Chức vụ: <span> {{ customerInfo.position || '' }}</span></span
          >
        </p>
      </div>

      <p>
        Hai bên cùng tiến hành kiểm tra tình trạng hoạt động của các thiết bị và cùng thống nhất
        việc sử dụng thiết bị theo các nội dung dưới đây:
      </p>
      <ul class="new-style-ul">
        <li>
          <p><b>THÔNG TIN THIẾT BỊ ĐƯỢC KIỂM TRA</b><br />Thông tin chi tiết như sau:</p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>Số TT</b></th>
                  <th><b>Serial thiết bị</b></th>
                  <th><b>Loại thiết bị</b></th>
                  <th><b>Địa chỉ đặt thiết bị</b></th>
                  <th><b>Số lượng (chiếc) </b></th>
                </tr>
              </thead>
              <tbody
                v-for="(item, index) in dataAppendix.appendixNganluongConvert &&
                dataAppendix.appendixNganluongConvert.deviceInfos.length > 0
                  ? dataAppendix.appendixNganluongConvert.deviceInfos
                  : []"
                :key="index"
              >
                <tr class="txt-center">
                  <td class="txt-center">{{ index + 1 }}</td>
                  <td>{{ item.serialNumber }}</td>
                  <td>
                    <span>
                      {{ item.displayName }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{
                        merchantBusinessAreasDevice[index] &&
                        merchantBusinessAreasDevice[index].areaAddress
                          ? merchantBusinessAreasDevice[index].areaAddress
                          : ''
                      }}
                    </span>
                  </td>
                  <td>{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>

        <li>
          <p><b>NỘI DUNG KIỂM TRA</b></p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>STT</b></th>
                  <th><b>NHÓM DỊCH VỤ</b></th>
                  <th><b>NỘI DUNG KIỂM TRA/HƯỚNG DẪN/BÀN GIAO</b></th>
                  <th><b>XÁC NHẬN</b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td><b>Khởi động thiết bị</b></td>
                  <td>Thao tác bật/ tắt và sạc pin cho thiết bị mới</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td rowspan="2"><b>Thanh toán thẻ</b></td>
                  <td>Nhận diện Thẻ chíp/Thẻ từ/Thẻ Contactless; ATM/Debit/Credit</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>
                    Quẹt với thẻ từ/ Cắm với thẻ chíp/ Chạm với thẻ Contactless/ In hoá đơn với
                    SmartPOS (nếu có giấy)
                  </td>
                  <td></td>
                </tr>
                <tr class="bg-head">
                  <td colspan="4"><b>Thanh toán thông thường/ Trả Góp 0%</b></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="2"><b>Thao tác sử dụng</b></td>
                  <td>Lựa chọn đúng mục thanh toán thường/ trả góp</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Lựa chọn ngân hàng và kỳ hạn</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td rowspan="3"><b>Quy trình hoàn thiện</b></td>
                  <td>Nhập thông tin hóa đơn và khách hàng (chủ thẻ)</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Theo từng quy trình của từng NH</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Các lưu ý "Maritimebank, Techcombank …"</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>6</b></td>
                  <td><b>Tài liệu hướng dẫn</b></td>
                  <td>Thông tin liên hệ các bộ phận Vận hành, Kỹ thuật</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>7</b></td>
                  <td><b>Các khoản phí</b></td>
                  <td>Phí trả góp, phí quẹt thẻ</td>
                  <td></td>
                </tr>
                <tr class="bg-head">
                  <td colspan="4"><b>Kiểm tra lịch sử giao dịch / Kết toán</b></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="5"><b>Xác nhận giao dịch</b></td>
                  <td>Lịch sử giao dịch trong ngày/ trước đó</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Kết toán giao dịch</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>Huỷ giao dịch/ Hoàn tiền giao dịch</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Gửi lại hoá đơn qua email</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Đăng nhập bằng email của Merchant trên Website của Bên A</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>

        <li>
          <p><b>THỎA THUẬN SỬ DỤNG THIẾT BỊ</b></p>
          <ul>
            <li style="text-align: justify">
              Thiết bị thuộc quyền sở hữu và sử dụng của Bên B, được Bên A kiểm tra, đánh giá và xác
              nhận tình trạng hoạt động là phù hợp với hệ thống thanh toán thẻ của Bên A.
            </li>
            <li style="text-align: justify">
              Bên A có quyền khóa thiết bị trên hệ thống của Bên A ngay lập tức trong trường hợp:
              <br />
              <p style="text-align: justify">
                <span class="mr-1">(i)</span> Bên B vi phạm bất kỳ điều khoản trong Hợp đồng cung
                cấp dịch vụ đã ký với Bên A;
              </p>
              <p style="text-align: justify">
                <span class="mr-1">(ii)</span> Bên B có thông báo cho Bên A bằng văn bản hoặc email
                về việc yêu cầu ngưng sử dụng;
              </p>
              <p style="text-align: justify">
                <span class="mr-1">(iii)</span> Thiết bị bị hỏng, không sử dụng được hoặc không còn
                đủ điều kiện để sử dụng. Trường hợp này, các Bên sẽ thỏa thuận về phương án thay thế
                thiết bị đủ điều kiện để tiếp tục sử dụng dịch vụ. kiện để tiếp tục sử dụng dịch vụ.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p><b>ĐIỀU KHOẢN THI HÀNH</b></p>
          <ul>
            <li style="text-align: justify">
              Biên bản thỏa thuận này là bộ phận không thể tách rời của Hợp đồng và các điều khoản
              khác của Hợp đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong
              Biên bản này.
            </li>
            <li style="text-align: justify">
              Biên bản thỏa thuận này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham
              gia ký kết. Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của
              Hợp đồng nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li style="text-align: justify">
              Biên bản thỏa thuận này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như
              nhau, mỗi Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ul>

      <FooterNL
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'

  export default {
    props: ['dataContract', 'appendix'],
    components: {
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract?.customerInfoRes ?? this.dataContract?.customerInfoCommon ?? {}
      },
      dataAppendix() {
        if (this.appendix && Object.keys(this.appendix).length > 0) return this.appendix
        return (
          this.dataContract.lstAppendixNganluongConverts?.find(e => e.isCreatedWithContract) ?? {}
        )
      },
      merchantBusinessAreasDevice() {
        if (!this.dataAppendix?.appendixNganluongConvert?.deviceInfos) return []
        return this.dataAppendix.appendixNganluongConvert.deviceInfos.map(s => {
          if (this.dataAppendix.merchantBusinessAreas) {
            return (
              this.dataAppendix.merchantBusinessAreas.find(z =>
                z.serials.includes(s.serialNumber)
              ) ?? {}
            )
          }
          return {}
        })
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
